import { Route, Routes } from "react-router";
import { LoginPageContent } from "./login/login";
import { Logout } from "./login/logout";
import RequireAuth from "./login/RequireAuth";


export function AuthRoutes() {
    return <Routes>
        <Route path={`/`} element={<LoginPageContent />} />
        <Route element={<RequireAuth />}>
            <Route path={'/logout'} element={<Logout />} />
        </Route>
    </Routes>
}